import { render, staticRenderFns } from "./DnDSource.vue?vue&type=template&id=1d03c5fe&"
import script from "./DnDSource.vue?vue&type=script&lang=ts&"
export * from "./DnDSource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports